<!-- PidePaYa Application -->
<router-outlet />
<!-- Toast global para mensajes de sesion expirada (mostrado desde el
     SessionExpiredHandlerService cuando un 401 expulsa al usuario al login).
     Vive aca para ser visible durante la transicion entre pantallas. -->
<p-toast position="top-center" key="session" />
